// extracted by mini-css-extract-plugin
export default {"buttonItem":"t24XlT"};